import React, { useContext, useState } from "react";
import FadeIn from "react-fade-in";

import dailyMoodCapture from "../../../assets/images/actions/mood_capture.png";
import wellnessCentre from "../../../assets/images/actions/wellness.png";
import moodCaptureCalendar from "../../../assets/images/actions/mood_calendar.png";
import peopleCalendar from "../../../assets/images/people_calendar.webp";
import supportConnect from "../../../assets/images/actions/support_connect.png";
import notifySupport from "../../../assets/images/actions/notify_support_person.png";
import questionnaires from "../../../assets/images/actions/question.gif";

import { UserContext } from "../../../storage/contexts/UserContext";
import { getTimeOfDay } from "../../../helpers/TimeOfDay";

import CommonDashboardItem from "../../../InterstellrComponents/CommonDashboardItem";
import NotifySupportPersonModal from "../../../InterstellrModals/NotifySupportPersonModal";
import { SUBMIT_SUPPORT_REQUEST } from "../../../Routes";
import axios from "axios";
import { generateURLOptions } from "../../../URLOptions";

const Dashboard = () => {
  const { profile } = useContext(UserContext);

  const [showNotify, setShowNotify] = useState(false);

  const submitSupportRequest = async (managerId) => {
    await axios
      .post(
        SUBMIT_SUPPORT_REQUEST,
        {
          managerId,
        },
        {
          headers: generateURLOptions(),
        },
      )
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <NotifySupportPersonModal
        isOpen={showNotify}
        onClose={() => setShowNotify(false)}
        onSubmit={(person) => {
          setShowNotify(false);
          submitSupportRequest(person?._id);
        }}
      />
      <div
        className="w-screen h-[90vh]"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <div className="container mx-auto flex flex-col justify-center items-center h-full w-full">
          <div className="w-full px-6 md:px-0 md:w-2/3">
            <FadeIn delay={200}>
              <div className="flex flex-col mb-4">
                <div className="flex flex-col">
                  <h4 className="font-normal text-black text-2xl">
                    {getTimeOfDay()}
                  </h4>

                  <h5 className="font-semibold text-black text-3xl mt-1 mb-4">
                    {profile?.firstname ?? ""} {profile?.lastname ?? ""}
                  </h5>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={350}>
              <CommonDashboardItem
                item={{
                  id: "daily-mood-capture",
                  name: "Daily Mood Capture",
                  image: dailyMoodCapture,
                  route: "/mood/capture",
                }}
              />
              {!profile?.schoolMode ? (
                <CommonDashboardItem
                  item={{
                    id: "wellness",
                    name: "Wellness",
                    image: wellnessCentre,
                    route: "/wellness",
                  }}
                />
              ) : null}
              <CommonDashboardItem
                item={{
                  id: "mood-capture-calendar",
                  name: "Mood Capture Calendar",
                  image: moodCaptureCalendar,
                  route: "/calendar/mood",
                }}
              />
              {profile?.usertype == 1 && profile?.schoolMode == false ? (
                <CommonDashboardItem
                  item={{
                    id: "mood-capture-calendar",
                    name: "People Calendar",
                    image: peopleCalendar,
                    route: "/people/calendar",
                  }}
                />
              ) : null}

              <CommonDashboardItem
                item={{
                  id: "questionnaires",
                  name: "Questionnaires",
                  image: questionnaires,
                  route: "/questionnaires",
                }}
              />
              {profile?.schoolMode ? (
                <CommonDashboardItem
                  item={{
                    id: "support-connect",
                    name: "Support Connect",
                    image: supportConnect,
                    route: "/wellness/support",
                  }}
                />
              ) : null}
              {profile?.schoolMode ? (
                <CommonDashboardItem
                  item={{
                    id: "notify-support",
                    name: "Notify Support Person",
                    image: notifySupport,
                    type: "action",
                    action: () => setShowNotify(true),
                  }}
                />
              ) : null}
            </FadeIn>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
